import MainDashboardAppConfig from './main/MainDashboardAppConfig';

const dashboardsConfigs = [
    MainDashboardAppConfig,
];

export default dashboardsConfigs;
